
import { createContext, useReducer } from "react";
import SettingReducer from "./SettingReducer";

const INITIAL_STATE = {
    settings: {},
    message: "",
    isFetchingGet: false,
    errorGet: false,
    isFetchingUpdate: false,
    errorUpdate: false,
};


export const SettingContext = createContext(INITIAL_STATE);

export const SettingContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(SettingReducer, INITIAL_STATE);
    
    return (
      <SettingContext.Provider
        value={{
          settings: state.settings,
          message: state.message,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          dispatch,
        }}
      >
        {children}
      </SettingContext.Provider>
    );
  };